var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-photo-area" },
    [
      _c(
        "draggable",
        {
          attrs: {
            options: { draggable: _vm.isEditing ? ".inputGroupItem" : "" },
          },
          on: { end: _vm.onEnd },
          model: {
            value: _vm.draggableList,
            callback: function ($$v) {
              _vm.draggableList = $$v
            },
            expression: "draggableList",
          },
        },
        [
          _vm._l(_vm.draggableList, function (item, index) {
            return _c(
              "div",
              {
                key: item.id,
                class: ["inputGroupItem", { draggable: _vm.isEditing }],
              },
              [
                _vm.isEditing
                  ? _c(
                      "div",
                      {
                        staticClass: "delete",
                        on: {
                          click: function ($event) {
                            return _vm._showDeleteModal(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { class: ["input-zone", { isEditingZone: _vm.isEditing }] },
                  [
                    _c("div", { staticClass: "div-facility" }, [
                      _c(
                        "label",
                        { class: { "required-flag": _vm.isEditing } },
                        [_vm._v(_vm._s(_vm.$t("handover.facility")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "facility-contant" },
                        [
                          _c("InputField", {
                            staticClass: "facility",
                            attrs: {
                              readonly: !_vm.isEditing,
                              showColon: false,
                              value: item.facility || "",
                              required: "",
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.updatePhotoInfo(
                                  "facility",
                                  index,
                                  val
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "div-description" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("handover.description"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [{ isEditing: _vm.isEditing }, "desc-contant"],
                        },
                        [
                          _c("TextField", {
                            staticClass: "description",
                            attrs: {
                              readonly: !_vm.isEditing,
                              showColon: false,
                              value: item.description
                                ? item.description
                                : !_vm.isEditing
                                ? "N/A"
                                : "",
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.updatePhotoInfo(
                                  "description",
                                  index,
                                  val
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["pic-display", { isEditing: _vm.isEditing }],
                    on: {
                      click: function ($event) {
                        return _vm._selectEditPhotoInfo(item, index)
                      },
                    },
                  },
                  [
                    _vm.isEditing && _vm.allowEdit
                      ? _c("upload-photo", {
                          ref: "upload-photo-" + item.id,
                          refInFor: true,
                          attrs: {
                            sourceId: item.id,
                            beforeUpload: _vm._beforeUpload,
                            uploadSuccess: _vm._uploadSuccess,
                            uploadError: _vm._uploadError,
                            targetItem: { item: item, index: index },
                            uploadTimeout: _vm._uploadTimeout,
                            additionalInfo: _vm.additionalInfo,
                            action: _vm.action,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (!item.files || item.files.length === 0) &&
                    _vm.isEditing &&
                    _vm.allowEdit
                      ? _c("div", { staticClass: "photo0 clearfix" }, [
                          _c("div", { staticClass: "border-dashed" }, [
                            _c("div", { staticClass: "center" }, [
                              _c("img", {
                                staticClass: "upload-img",
                                attrs: {
                                  src: "/cloud-upload.svg",
                                  alt: "Upload",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("tender.attachment.uploadClickHint")
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _c(
                          "div",
                          {
                            class: item.files.length <= 2 ? "photo2" : "photo4",
                          },
                          _vm._l(item.files, function (photo) {
                            return _c(
                              "div",
                              { key: photo.id, staticClass: "photo-contain" },
                              [
                                _c("img", {
                                  staticClass: "photo",
                                  attrs: {
                                    src: _vm.getImageUrl(photo),
                                    id: photo.id,
                                  },
                                  on: {
                                    load: function ($event) {
                                      return _vm.showPhoto(
                                        photo,
                                        item.files.length
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.isEditing && _vm.allowEdit
                                  ? _c("i", {
                                      staticClass: "fa fa-times delete-photo",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm._deleteOnePhoto(
                                            photo,
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                  ],
                  1
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "modal",
            {
              ref: "deleteMakeSureModal",
              attrs: { modalId: "delete-make-sure-modal" },
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("pre", { staticClass: "modal-pure-text" }, [
                  _vm._v(_vm._s(_vm.$i18n.t("deleteConfirmMsg"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: { click: _vm._deleteOnePhotoInfo },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.delete")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    on: { click: _vm._closeDeleteModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                ),
              ]),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }